export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14847.fb8cfee5.jpg";